import { Heading } from "@planningcenter/doxy-web"
import { css } from "@emotion/react"
import { Link } from "react-router-dom"
import { Icon } from "source/shared/components"
import RecurringDonationsList from "./RecurringDonationsList"
import PledgesList from "./PledgesList"
import { usePlannedGivingContext } from "../hooks/usePlannedGivingContext"
import usePaymentMethodsUrl from "../hooks/usePaymentMethodsUrl"

export default function PlannedGivingContent() {
  const { recurringDonations, pledges, pledgeCampaigns, jointGiver } =
    usePlannedGivingContext()

  const paymentMethodsUrl = usePaymentMethodsUrl()

  return (
    <section>
      <div className="d-f fd-c g-2">
        <div className="d-n d-f@md">
          <Heading level={1} size={2} text="Planned giving" />
        </div>
        <div
          className="d-f fd-c g-2 p-2"
          css={css`
            border: 1px solid var(--color-static-gray93);
            border-radius: 8px;
          `}
        >
          <div className="d-f jc-sb ai-c">
            <Heading level={2} size={3} text="Recurring donations" />
            <Link
              to="/giving?recurring=true"
              className="btn outline-btn sm-btn d-f g-1"
            >
              <Icon
                symbol="general#plus"
                aria-hidden="true"
                css={css`
                  height: 12px;
                  width: 12px;
                `}
              />
              New
            </Link>
          </div>
          {recurringDonations && (
            <RecurringDonationsList
              recurringDonations={recurringDonations}
              showFullDetails={true}
            />
          )}
          <Link to={paymentMethodsUrl} className="fs-13 fw-500">
            Manage payment methods
          </Link>
        </div>
        {pledges && pledgeCampaigns && pledges.length > 0 && (
          <div
            className="d-f fd-c g-2 p-2"
            css={css`
              border: 1px solid var(--color-static-gray93);
              border-radius: 8px;
            `}
          >
            <Heading level={2} size={3} text="Pledges" />
            <PledgesList
              jointGiver={jointGiver}
              pledgeCampaigns={pledgeCampaigns}
              pledges={pledges}
              showFullDetails={true}
            />
          </div>
        )}
      </div>
    </section>
  )
}
